import React from "react";

// @material-ui components
import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
  Grow,
  Theme,
} from "@material-ui/core";
import { Close as CloseIcon, Check as CheckIcon } from "@material-ui/icons";

import { TransitionProps } from "@material-ui/core/transitions";

import { useRecoilState } from "recoil";

import { grey, indigo, red } from "@material-ui/core/colors";
import { confirmationDialogState } from "../../GlobalAtoms";

const confirmationDialogStyle = makeStyles(({ spacing }: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: spacing(2),
    },
    cancelButton: {
      color: grey[50],
      backgroundColor: red[800],
      "&:hover": {
        backgroundColor: red[900],
      },
    },
    confirmButton: {
      color: grey[50],
      backgroundColor: indigo[700],
      "&:hover": {
        backgroundColor: indigo[600],
      },
    },
  })
);

const Transition = React.forwardRef(
  (props: TransitionProps, ref: React.Ref<unknown>) => (
    <Grow ref={ref} {...props} />
  )
);

const ConfirmationDialogWrapper = () => {
  const [confirmationDialog, setConfirmationDialogState] = useRecoilState(
    confirmationDialogState
  );

  const customClasses = confirmationDialogStyle();

  const confirm = () => {
    if (confirmationDialog.action) {
      confirmationDialog.action();
    }
    setConfirmationDialogState({
      open: false,
      transition: "default",
    });
  };

  return (
    <>
      {confirmationDialog.open && (
        <Dialog
          open={confirmationDialog.open}
          fullWidth
          maxWidth="xs"
          scroll="paper"
          aria-labelledby="alert-confirmationDialog-title"
          aria-describedby="alert-confirmationDialog-description"
          TransitionComponent={Transition}
        >
          <DialogContent>
            <DialogContentText>{confirmationDialog.question}</DialogContentText>
          </DialogContent>
          {confirmationDialog.action ? (
            <DialogActions>
              <Button
                className={customClasses.cancelButton}
                onClick={() =>
                  setConfirmationDialogState({
                    open: false,
                    transition: "default",
                  })
                }
                size="small"
                startIcon={<CloseIcon />}
                variant="contained"
              >
                Cancelar
              </Button>
              <Button
                autoFocus
                className={customClasses.confirmButton}
                onClick={confirm}
                size="small"
                startIcon={<CheckIcon />}
                variant="contained"
              >
                Confirmar
              </Button>
            </DialogActions>
          ) : (
            <DialogActions>
              <Button
                className={customClasses.cancelButton}
                onClick={() =>
                  setConfirmationDialogState({
                    open: false,
                    transition: "default",
                  })
                }
                size="small"
                startIcon={<CloseIcon />}
                variant="contained"
              >
                Fechar
              </Button>
            </DialogActions>
          )}
        </Dialog>
      )}
    </>
  );
};

export default ConfirmationDialogWrapper;
